/**
 * StickerBadge — circular badge with peeled sticker look
 */

import { ReactNode } from 'react';

interface StickerBadgeProps {
  children: ReactNode;
  color?: string;
  rotation?: number;
  className?: string;
}

export default function StickerBadge({
  children,
  color = 'var(--kid-dandelion)',
  rotation = -3,
  className = '',
}: StickerBadgeProps) {
  return (
    <div
      className={`inline-flex items-center justify-center rounded-full p-4 font-display text-white shadow-lg ${className}`}
      style={{
        backgroundColor: color,
        transform: `rotate(${rotation}deg)`,
        boxShadow: `3px 4px 0 rgba(151, 117, 250, 0.15), 0 8px 20px rgba(0,0,0,0.1)`,
      }}
    >
      {children}
    </div>
  );
}
